export default __webpack_public_path__ + "static/media/hallstatt.4a67a9f2.jpg";